import type { ListSchema } from './schema'

export function filterBySearch<T>(
  records: readonly T[],
  schema: ListSchema<T>,
  search: string,
): readonly T[] {
  const needle = search.trim().toLowerCase()
  if (!needle) return records

  const searchableFields = schema.fields.filter(
    field => field.searchable !== false,
  )
  if (searchableFields.length === 0) return []

  const filteredRecords = records.filter(record =>
    searchableFields.some(field => {
      const text = field.searchText
        ? field.searchText(record)
        : String(field.value(record) ?? '')
      return text.toLowerCase().includes(needle)
    }),
  )
  return filteredRecords.length === records.length ? records : filteredRecords
}
